import { expensifyUnlinkSuccess } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

const unlinkExpensifySuccess = () => addMessage(expensifyUnlinkSuccess);
export default unlinkExpensifySuccess;
